import React from "react";

import styled from "styled-components";

import ManuscriptHistoryPanel from "components/organisms/manuscript/history/ManuscriptHistoryPanel";
import ManuscriptPdfPanel from "components/organisms/manuscript/pdf/ManuscriptPdfPanel";
import ManuscriptReviewPanel from "components/organisms/manuscript/review/ManuscriptReviewPanel";

const PANEL_LABELS = {
    pdf: "PDF",
    history: "히스토리",
    review: "리뷰",
};

const Panel = styled.section`
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    background: var(--color-White);
`;

const PanelHeader = styled.div`
    display: flex;
    align-items: center;
    height: 44px;
    padding: 0 14px;
    border-bottom: solid 1px var(--color-Line);
    flex-shrink: 0;
    font-size: 1.5rem;
    font-weight: 500;
    color: var(--color-SubBlack);
`;

const PanelBody = styled.div`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

function ManuscriptRightPanel({
    activePanel,
    latestCompile,
    pdfArtifact,
    pdfRevisionSeq,
    logArtifact,
    compileRevisionSeq,
    compileLogRaw,
    compileLogEntries,
    compileLogLoading,
    compileLogLoadError,
    onCompile,
    onLogEntrySelect,
    compileLoading,
    compileDisabled,
    compileHasLintError,
    compileDisabledReason,
    historyItems,
    highlightedRevisionId,
    restoreMutation,
    handleRestoreRevision,
    saveLabel,
    reviewThreads,
    selectedReviewThreadId,
    onSelectReviewThread,
    onReviewThreadMount,
}) {
    return (
        <Panel>
            <PanelHeader>{PANEL_LABELS[activePanel] || activePanel}</PanelHeader>
            <PanelBody>
                {activePanel === "pdf" ? (
                    <ManuscriptPdfPanel
                        latestCompile={latestCompile}
                        pdfArtifact={pdfArtifact}
                        pdfRevisionSeq={pdfRevisionSeq}
                        logArtifact={logArtifact}
                        compileRevisionSeq={compileRevisionSeq}
                        compileLogRaw={compileLogRaw}
                        compileLogEntries={compileLogEntries}
                        compileLogLoading={compileLogLoading}
                        compileLogLoadError={compileLogLoadError}
                        onCompile={onCompile}
                        onLogEntrySelect={onLogEntrySelect}
                        compileLoading={compileLoading}
                        compileDisabled={compileDisabled}
                        compileHasLintError={compileHasLintError}
                        compileDisabledReason={compileDisabledReason}
                    />
                ) : null}

                {activePanel === "history" ? (
                    <ManuscriptHistoryPanel
                        historyItems={historyItems}
                        highlightedRevisionId={highlightedRevisionId}
                        restoreMutation={restoreMutation}
                        handleRestoreRevision={handleRestoreRevision}
                        saveLabel={saveLabel}
                    />
                ) : null}

                {activePanel === "review" ? (
                    <ManuscriptReviewPanel
                        reviewThreads={reviewThreads}
                        selectedReviewThreadId={selectedReviewThreadId}
                        onSelectReviewThread={onSelectReviewThread}
                        onReviewThreadMount={onReviewThreadMount}
                    />
                ) : null}
            </PanelBody>
        </Panel>
    );
}

export default ManuscriptRightPanel;
